/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Material
import Drawer from '@material-ui/core/Drawer';

// Types
import { CompanyInterface } from 'store/ducks/companies/types';

// Components
import { CompanyNavigation } from './CompanyNavigation';

// Styles
import useStyle from './companyDrawer.styles';

interface InfoDrawerProps {
  toggleDrawer(open: boolean, data?: any): (event: any) => void;
  companyData: CompanyInterface;
  open: boolean;
  transportVouchers?: boolean;
}

type Props = InfoDrawerProps;

const CompanyDrawer: React.FC<Props> = ({
  open,
  companyData,
  toggleDrawer,
  transportVouchers,
}) => {
  const classes = useStyle();

  return (
    <Drawer anchor='right' onClose={toggleDrawer(false)} open={open}>
      <div className={classes.drawerContents}>
        <CompanyNavigation
          companyData={companyData}
          transportVouchers={transportVouchers}
        />
      </div>
    </Drawer>
  );
};

export { CompanyDrawer };
export default CompanyDrawer;
